import type { MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode } from "@similarweb/pro-api-client";

import {
    type KeywordsBreakdownTableRow,
    isNewKeywordRow,
    processKeywordsBreakdownData,
} from "../../keywords-breakdown-widget/keywordsBreakdownTableDataSelector";
import { useSearchTrendsQuery } from "../shared/useSearchTrendsQuery";

import type { INewKeywordsCardData } from "./newKeywords.types";

const MAX_NEW_KEYWORDS = 5;

export const selectNewKeywordsCardData = (rows: KeywordsBreakdownTableRow[]): INewKeywordsCardData => {
    const newRows = rows.filter(isNewKeywordRow).toSorted((left, right) => right.MonthlyVolume - left.MonthlyVolume);

    return {
        topRows: newRows.slice(0, MAX_NEW_KEYWORDS).map((row) => ({
            id: row.id,
            keyword: row.SearchTerm,
            volume: row.MonthlyVolume,
        })),
        totalNewCount: newRows.length,
    };
};

const selectNewKeywordsCard = (
    data: MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode,
): INewKeywordsCardData => selectNewKeywordsCardData(processKeywordsBreakdownData(data));

export const useNewKeywordsCard = () =>
    useSearchTrendsQuery("marketResearchDemandAnalysisSearchTrendsList", selectNewKeywordsCard);
